/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geotiercountry2Inputs */

const en_geotiercountry2 = /** @type {(inputs: Geotiercountry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Austria`)
};

const de_geotiercountry2 = /** @type {(inputs: Geotiercountry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Österreich`)
};

/**
* | output |
* | --- |
* | "Austria" |
*
* @param {Geotiercountry2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geotiercountry2 = /** @type {((inputs?: Geotiercountry2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geotiercountry2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geotiercountry2(inputs)
	return de_geotiercountry2(inputs)
});
export { geotiercountry2 as "geoTierCountry" }